import ReportEditRecommendations from './reportEditRecommendations'
export default ReportEditRecommendations
